import warsawBackgroundVideo from "assets/videos/background-video-placeholder-warsaw-v2.mp4";
import warsawBackgroundMobileVideo from "assets/videos/mobile-background-video-warsaw-v2.mp4";

import { banners } from "../banners.js";
import { getSchoolsConfig } from "../pl-schoolsConfig.js";

export const getWarszawaBoxConfig = () => {
  return {
    cityOptions: {
      isInLocationsPage: true,
      isCityInProgress: false,
      title: "WARSZAWA - BOX",
      label: "Pixel XL BOX",
      siteUrl: "/warszawa-box",
      siteTitle: "Pixel XL Warszawa - BOX",
      statue: "/documents/warszawa/statue.pdf",
      nameKey: "warszawa-box",
      isPerformanceReviewEnabled: true,
      street: "arkadia",
    },
    mainSection: {
      isVisible: true,
      plan4uApiUrl: "https://xl.plan4u.pl/pixel/warszawa/api/v1",
      youtubeBackgroundVideoID: "laHMFboSpmo",
      youtubeMobileBackgroundVideoID: "13te_ICxgnU",
    },
    aboutSection: {
      isVisible: true,
      aboutUsImages: [
        "/images/warszawa-box/about-us/about-picture-1.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-2.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-3.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-4.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-5.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-6.v2.jpg",
      ],
      aboutUsMobileImages: [
        "/images/warszawa-box/about-us/about-picture-1.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-2.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-3.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-4.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-5.v2.jpg",
        "/images/warszawa-box/about-us/about-picture-6.v2.jpg",
      ],
      pixelBoxBanner: banners.pixelBox,
    },
    bookingSection: {
      isVisible: true,
      isBookLinkEnabled: true,
      bookingUrl: {
        eng: "https://xl.plan4u.pl/pixel/warszawa/bookItNEW_EN.html",
        de: "https://xl.plan4u.pl/pixel/warszawa/bookItNEW_DE.html",
        pl: "https://xl.plan4u.pl/pixel/warszawa/bookItNEW_PL.html",
      },
      banners: banners.booking["warszawa-box"],
    },
    priceSection: {
      isVisible: true,
      priceBanner: banners.price[25],
    },
    descriptionSection: {
      isVisible: true,
    },
    voucherSection: {
      voucherBanner: banners.voucher,
      isVisible: true,
      voucherPageUrl: "https://xl.plan4u.pl/pixel/warszawa/getVoucher.html",
    },
    cooperationSection: {
      isVisible: true,
      isHrefEnabled: true,
      cooperationSectionVisibility: true,
      integrationOfferVisibility: false,
      birthdayOfferVisibility: false,
      schoolOfferVisibility: true,
      schoolPage: getSchoolsConfig()["warszawa-box"],
    },
    reviewSection: {
      isVisible: true,
    },
    faqSection: {
      isVisible: true,
    },
    careerSection: {
      isVisible: true,
    },
    contactSection: {
      isVisible: true,
      isMapVisible: true,
      googleMapsOptions: {
        city: "Warszawa",
        country: "Poland",
        street: "Jana pawła II+82",
      },
      address: "al. Jana Pawła II 82, 00-175 Warszawa",
      email: "warszawa@pixel-xl.com",
    },
  };
};
